import { NavLink } from "react-router-dom";
import { FaUsers, FaChartBar, FaCode, FaLock, FaCog, FaList, FaRandom, FaUserTag } from "react-icons/fa";

const Sidebar = ({ project }) => {
  return (
    <aside id="sidebar" className="sidebar">
      <ul className="sidebar-nav" id="sidebar-nav">
        <li className="nav-item">
          <NavLink to="/" className="nav-link">
            <i className="bi bi-grid"></i>
            <span>Dashboard</span>
          </NavLink>
        </li>

        {project.menu.items.map((item, index) => (
          <li className="nav-item" key={index}>
            {item.childs ? (
              <>
                <a
                  href="#"
                  {...item.htmlattribute}
                >
                  <i className={item.icon}></i>
                  <span>{item.label}</span>
                  <i className="bi bi-chevron-down ms-auto"></i>
                </a>
                <ul id={item.id} className="nav-content collapse" data-bs-parent="#sidebar-nav">
                  {item.childs.map((child, childIndex) => (
                    <li key={childIndex}>
                      <NavLink to={child.url}>
                        <i className={child.icon}></i>
                        <span>{child.label}</span>
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </>
            ) : (
              <NavLink {...item.htmlattribute}>
                <i className={item.icon}></i>
                <span>{item.label}</span>
              </NavLink>
            )}
          </li>
        ))}
      </ul>
    </aside>
  );
};

export default Sidebar; 